import Vue from 'vue';
import { setup, getStore } from './precore';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

setup(Vue);
const store = getStore();

const getuser = Vue.http.get('/api/user/ping').then(res => {
    store.commit('initUser', res.body);
}).finally(() => {
    new Vue({
        store,
        i18n: require('./i18n').setup(Vue),
        router,
        render: function (h) {
            return h(App);
        },
    }).$mount('#app');
});

router.beforeEach((to, from, next) => {
    getuser.then(() => {
        if (to.meta.loggedIn === true && !store.state.user.loggedIn) {
            return next({
                path: 'login',
                query: { page: to.fullPath },
            });
        }
        next();
    });
});
